// Error page component for displaying error messages and handling navigation
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton, Button, AhuaIcon } from '@yaradigitallabs/ahua-react';

import { useAppDispatch, useAppSelector } from '@/app/hooks';
import routes from '@/app/routes';
import { setGlobalError } from '@/app/coreSlice';
import { selectGlobalError } from '@/app/selector';
import { Colors } from '../../../public/GlobalTokens';
import { setResponseErrorStatus } from '@/features/session/store/sessionSlice';
// Props for ErrorPage component
interface ErrorPageProps {
  errorStatusCode?: number; // Optional error status code (e.g., 404)
  isMicroFrontend?: boolean; // Flag to indicate if it's rendered as a micro-frontend
}

// ErrorPage component displays error info and navigation options
const ErrorPage = ({ errorStatusCode, isMicroFrontend }: ErrorPageProps) => {
  const navigate = useNavigate(); // For navigation
  const dispatch = useAppDispatch(); // For dispatching Redux actions
  const globalError = useAppSelector(selectGlobalError); // Global error from Redux

  const handleGoToLogin = () => {
    dispatch(setResponseErrorStatus(0)); // Clear error status in Redux
    navigate(routes.LOGIN); // Navigate to login page
  };
  const renderErrorMessage = () => {
    if (errorStatusCode === 404) {
      return (
        <div>
          <h2 className="text-2xl font-bold">
            An error occurred. Contact your IT department to get help.
          </h2>
          <p className="mt-10 flex justify-center">
            The requested URL was not found on this server.
          </p>
        </div>
      );
    } else if (errorStatusCode === 401 || errorStatusCode === 403) {
      return (
        <div
          id={`unauthorized-error`}
          className={`p-8 my-4 rounded max-w-[100%] text-red-800 rounded-lg bg-[#FDECEA] flex flex-col items-center gap-y-8`}
        >
          <div className="flex gap-x-4 items-center">
            <div>
              <AhuaIcon
                type="filled"
                icon="Bangcircle"
                colorConcept="warning"
                className="w-12 h-12"
              />
            </div>

            <p>
              You do not have an account for Soft tag manager. To get access,
              please follow the instructions in&nbsp;
              <a
                href="https://yara-global.atlassian.net/wiki/spaces/DPT/pages/2783150117/STM+Access+Request+Guide"
                target="_blank"
                className="text-blue-500 underline hover:text-yara-bright-blue"
              >
                here
              </a>
              .
            </p>
          </div>
          {isMicroFrontend ? null : (
            <Button
              css={{ width: '40%' }}
              className="font-noto-sans"
              size="xs"
              onClick={event => handleGoToLogin()}
            >
              Go to Login Page
            </Button>
          )}
        </div>
      );
    }
  };
  return (
    <section className="min-h-[calc(100vh-60px)] flex flex-col items-center justify-center py-12">
      {renderErrorMessage()}
    </section>
  );
};

export default ErrorPage;
